
	import { Component } from 'vue-property-decorator';
	import { BaseView } from '@shared/views/BaseView';

	@Component({})
	export default class MobileMenu extends BaseView {

		public visible: boolean = false;

	}
	
